const tariff = new Map();

tariff.set('1116', 1.90);
tariff.set('1611', 2.90);
tariff.set('1117', 1.70);
tariff.set('1711', 2.70);
tariff.set('1118', 0.90);
tariff.set('1811', 1.90);

export default tariff;